import React, { useCallback, useEffect, useState } from 'react'

import { Picker } from '../../../../module'
import { type InputRule } from './validationService'

type TypeProps = {
  validationRules: InputRule
  initialValue: string | number | boolean | unknown
  callbackValue: (value: string | number) => void
  header: string
}
type TypeToggle = {
  id: number
  text: string
  value: string
}
const EditCellBoolean = ({
  validationRules,
  initialValue,
  callbackValue,
  header,
}: TypeProps) => {
  const [booleanOptions, setBooleanOptions] = useState<TypeToggle[]>([])
  const [activeBoolean, setActiveBoolean] = useState<TypeToggle>()

  useEffect(() => {
    const booleanOptions: TypeToggle[] = []
    const options: any = validationRules?.options

    const isArrayOption = Array.isArray(options)
    if (isArrayOption) {
      options?.map((list, index) => {
        booleanOptions.push({
          id: index,
          text: list?.toString() ?? '',
          value: list.toString(),
        })
      })
    } else {
      Object.entries(options).forEach(([key, value], index) => {
        booleanOptions.push({
          id: index,
          text: value?.toString() ?? '',
          value: key.toString(),
        })
      })
    }

    setBooleanOptions(booleanOptions)
    const activeOption = booleanOptions.find((item) => {
      return item.value === initialValue?.toString()
    })
    setActiveBoolean(activeOption)
  }, [initialValue, validationRules?.data_type, validationRules?.options])

  const changeBoolean = useCallback(
    (value: string) => {
      const activeOption = booleanOptions.find((item) => item.value === value)
      setActiveBoolean(activeOption)
      callbackValue(value)
    },
    [booleanOptions, callbackValue],
  )

  return (
    <Picker
      options={booleanOptions ?? []}
      labelText={header}
      state={activeBoolean}
      stateName='value'
      callout={(_, value) => changeBoolean(value)}
    />
  )
}

export default EditCellBoolean
